<div class="advanced-search-container" [ngClass]="{backround : isDarkMode}">
  <header class="search-header" [ngClass]="{'backround-section' : isDarkMode}">
    <div class="header">
      <div class="logo-container">
        <h1>Advanced Search IP Economic Testing</h1>
      </div>
      <div class="profil">
        <app-profile [header]="true"></app-profile>
        <div class="icl-logo">
          <img *ngIf="isDarkMode === false" src="./assets/images/logo-in.png" alt="ICL Logo" />
          <img *ngIf="isDarkMode" src="./assets/images/logo-in-d.png"  alt="ICL Logo"/>
        </div>
      </div>
  </div>
  </header>
  

  <div class="search-content" >

    <div class="search-section search-filters" [ngClass]="{'backround-section' : isDarkMode}">
        <div class="back-button-container">
          <button class="back-button" type="button" (click)="goBack()" [ngClass]="{'color-dark' : isDarkMode}">
            <img *ngIf="isDarkMode === false" class="goBack" 
            src="../../../assets/images/light/icons8-left-arrow-light.png" alt="ICL Logo" />
            <img *ngIf="isDarkMode" class="goBack"  src="../../../assets/images/dark/icons8-left-arrow-dark.png"  alt="ICL Logo"/>
            Back
          </button>
        </div>

        <div class="global-search-container">
          <div class="search-input">
            <input type="text" placeholder="Search" [formControl]="freeSearchControl" [ngClass]="isDarkMode ? ['backround-section', 'color-dark'] : []">
            <button type="button" class="search-icon">
                <mat-icon>search</mat-icon>
            </button>
          </div>
        </div>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="onSearch()" >
      <div class="search-filters" [ngClass]="isDarkMode ? ['backround-section', 'color-dark'] : []">
        <div class="filter-row">
          <div class="filter-column">
            <label>User</label>
            <div class="dropdown-container" (clickOutside)="onClickOutside('user')">
                  <mat-form-field appearance="fill" [ngClass]="{ 'dark-form-field': isDarkMode }">
                    <mat-label>Select User</mat-label>
                    <mat-select #userSelect [formControl]="selectedUsersControl" multiple  [panelClass]="isDarkMode ? 'dark-select-panel custom-dropdown-width' : 'custom-dropdown-width'">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="userFilterCtrl" placeholderLabel="Search..."></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let user of filteredUsers" [value]="user.user_name">
                        {{ user.user_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
          </div>
          <div class="filter-column">
            <label>Folder / File Name</label>
            <div class="dropdown-container" (clickOutside)="onClickOutside('folder')">
              <mat-form-field appearance="fill" class="mat-form-field-folder" [ngClass]="{ 'dark-form-field': isDarkMode }">
                <mat-label>Select Sub Folder</mat-label>
                <mat-select #folderSelect [formControl]="selectedSubFolderControl" multiple [panelClass]="isDarkMode ? 'dark-select-panel custom-dropdown-width' : 'custom-dropdown-width'">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="subFolderFilterCtrl" placeholderLabel="Search..."></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let folder of filteredSubFolders" [value]="folder.name">
                    {{ folder.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-column">
            <label>File Format</label>
            <div class="file-format-container">
              <div class="file-format-tags" >
                <div class="file-format-tag" [ngClass]="{'back-tag' : isDarkMode}"
                     *ngFor="let format of fileFormats"
                     [class.selected]="format.selected"
                     (click)="toggleFileFormat(format)">
                  {{ format.value }}
                  <mat-icon *ngIf="format.selected">close</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-column">
            <label>From Date</label>
            <div class="date-input">
              <input type="date" formControlName="fromDate" [ngClass]="{'back-date' : isDarkMode}">
            </div>
          </div>

          <div class="filter-column">
            <label>To Date</label>
            <div class="date-input">
              <input type="date" formControlName="toDate" [ngClass]="{'back-date' : isDarkMode}">
            </div>
          </div>

          <div class="filter-column-2">
            <div class="filter-column checkbox-column">
                <label class="checkbox-label">
                  <input type="checkbox" formControlName="sortByLastModified">
                  <span>Sort by Last Modified Date</span>
                </label>
              </div>

              <div class="actions-column">
                <button type="submit" class="search-button">Search</button>
                <button type="button" class="clear-button" (click)="clearForm()">Clear</button>
              </div>
          </div>
        </div>
      </div>
    </form>

    <div class="results-section" [ngClass]="isDarkMode ? ['backround-section', 'color-dark'] : []">
      <!-- Here will be the table in the future, but it's empty for now as requested -->
      <div class="table-container" [ngClass]="isDarkMode ? 'dark-table' : 'light-table'">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" >

          <ng-container matColumnDef="Document name">
            <th mat-header-cell *matHeaderCellDef> Document Name </th>
            <td mat-cell *matCellDef="let element"> {{element['Document name']}} </td>
          </ng-container>
        
          <ng-container matColumnDef="Document format">
            <th mat-header-cell *matHeaderCellDef> Format </th>
            <td mat-cell *matCellDef="let element"> {{element['Document format']}} </td>
          </ng-container>
        
          <ng-container matColumnDef="Document creator">
            <th mat-header-cell *matHeaderCellDef> Creator </th>
            <td mat-cell *matCellDef="let element"> {{element['Document creator']}} </td>
          </ng-container>
        
          <ng-container matColumnDef="Creation date">
            <th mat-header-cell *matHeaderCellDef> Created </th>
            <td mat-cell *matCellDef="let element"> {{element['Creation date'] | date}} </td>
          </ng-container>
        
          <ng-container matColumnDef="Modification date">
            <th mat-header-cell *matHeaderCellDef> Modified </th>
            <td mat-cell *matCellDef="let element"> {{element['Modification date'] | date}} </td>
          </ng-container>

          <ng-container matColumnDef="Document location">
            <th mat-header-cell *matHeaderCellDef> Location </th>
            <td mat-cell *matCellDef="let element" (click)="copyToClipboard(element['Document location'])" style="cursor: pointer;">
                {{ element['Document location'] }}
            </td>
          </ng-container>
        
          <!-- <ng-container matColumnDef="Document location">
            <th mat-header-cell *matHeaderCellDef> Location </th>
            <td mat-cell *matCellDef="let element"> 
              <a *ngIf="element['Document location']"
                [href]="element['Document location']"
                target="_blank"
                rel="noopener noreferrer"
                class="link-style">
                {{ element['Document location'] }}
              </a>
            </td>
          </ng-container> -->
        
          <ng-container matColumnDef="Page">
            <th mat-header-cell *matHeaderCellDef> Pages </th>
            <td mat-cell *matCellDef="let element"> 
                <div class="clamp-text" [matTooltip]="element['Page']" matTooltipClass="custom-tooltip">
                    {{ element['Page'] }}
                  </div>
                  <!-- {{element['Page']}}  -->
                </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        
        </table>

        <mat-paginator 
        [pageSize]="10" 
        [pageSizeOptions]="[5, 10, 25]" 
        showFirstLastButtons
        [ngClass]="isDarkMode ? 'dark-paginator' : ''">
        ></mat-paginator>
      </div>
      <div class="dataMessage">{{dataMeessage}}</div>
    </div>
  </div>
</div>
